import { ANYTIME_PREFERENCE_VALUE } from 'constants/advancedSearch';
import isObject from 'lodash/isObject';

import { PRIORITY_MAP } from './Filters.constants';

const flattenFilterEntries = filterData => {
  const { fieldName, preferencesFieldName, value } = filterData;

  if (fieldName && Array.isArray(value)) {
    return value.map(item => ({
      ...item,
      fieldName,
      preferencesFieldName
    }));
  }

  if (fieldName && isObject(value)) {
    return [
      {
        ...value,
        fieldName,
        preferencesFieldName
      }
    ];
  }

  return [];
};

const createFilterKey = (fieldName, priority) => `${fieldName}___${priority}`;
const createPreferenceFilterKey = (fieldName, preference, priority) =>
  `${createFilterKey(fieldName, priority)}___${preference}`;

const buildPreferenceFilter = ({ fieldName, preferencesFieldName, preference, priority }) => ({
  priority,
  filters: [
    {
      field: fieldName,
      value: []
    },
    {
      field: preferencesFieldName,
      value: preference
    }
  ]
});

const normalizeTimePreferenceValue = preference => ({
  last: preference === ANYTIME_PREFERENCE_VALUE ? null : preference
});

export const createFiltersRequestPayload = formValues => {
  if (!formValues || typeof formValues !== 'object') {
    return {
      filters: [],
      size: 10
    };
  }

  const filters = Object.values(formValues)
    .flatMap(flattenFilterEntries)
    .reduce((acc, item) => {
      const priority = PRIORITY_MAP[item.priority] || PRIORITY_MAP.must_have;
      const isPreferenceFieldSet = Boolean(
        item.preferencesFieldName && item.preference !== undefined
      );

      if (isPreferenceFieldSet) {
        const preferenceKey = createPreferenceFilterKey(item.fieldName, item.preference, priority);

        if (!acc[preferenceKey]) {
          acc[preferenceKey] = buildPreferenceFilter({
            fieldName: item.fieldName,
            preferencesFieldName: item.preferencesFieldName,
            preference: normalizeTimePreferenceValue(item.preference),
            priority
          });
        }

        if (typeof item.item.value === 'string' || typeof item.item.value === 'number') {
          acc[preferenceKey].filters[0].value.push(item.item.value);
          return acc;
        }

        acc[preferenceKey].filters[0].value = item.item.value;
        return acc;
      }

      const key = createFilterKey(item.fieldName, priority);

      if (!acc[key]) {
        acc[key] = {
          field: item.fieldName,
          priority,
          value: []
        };
      }

      if (typeof item.item.value === 'string' || typeof item.item.value === 'number') {
        acc[key].value.push(item.item.value);
        return acc;
      }

      acc[key].value = item.item.value;
      return acc;
    }, {});

  return {
    filters: Object.values(filters),
    size: 10
  };
};
